<template>
  <div class="h-100 d-block overflow-scroll">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      :fields="fields"
      :items="dataList"
      small
      fixed
    >
      <template #cell(sales)="data">
        <template v-if="data.index > 2">
          {{ data.item.sales | toNumber }} ₺
        </template>
        <template v-else>
          <div class="d-flex justify-content-between">
            <div class="text-primary">
              % {{ data.item.sales_percent | toNumber }}
            </div>
            <div>{{ data.item.sales | toNumber }}</div>
          </div>
        </template>
      </template>
      <template #cell(i2Sales)="data">
        <template v-if="data.index !== 2">
          <template v-if="data.index > 2">
            {{ data.item.i2Sales | toNumber }} ₺
          </template>
          <template v-else>
            <div class="d-flex justify-content-between">
              <div class="text-primary">
                % {{ data.item.i2Sales_percent | toNumber }}
              </div>
              <div>{{ data.item.i2Sales | toNumber }}</div>
            </div>
          </template>
        </template>
        <template v-else>
          -
        </template>
      </template>
      <template #custom-foot>
        <b-tr>
          <b-th class="d-flex justify-content-between align-items-center">
            <div>
              Adet Toplam
            </div>
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.salesCountTotal | toNumber }}
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.i2SalesCountTotal | toNumber }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="d-flex justify-content-between align-items-center">
            <div>
              Komisyon Toplam
            </div>
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.salesAmountTotal | toNumber }} ₺
          </b-th>
          <b-th class="text-right">
            {{ grandTotals.i2SalesAmountTotal | toNumber }} ₺
          </b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BTh, BTr,
} from 'bootstrap-vue'

export default {
  name: 'TablePerformance',
  components: {
    BTr,
    BTh,
    BTable,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: '',
          sortable: true,
          thClass: 'font-small-2 align-middle text-nowrap',
          tdClass: 'font-weight-bold text-body',
        },
        {
          key: 'sales',
          label: 'Sıfır Satış',
          sortable: true,
          thClass: 'font-small-2 text-nowrap text-right align-middle',
          tdClass: 'text-right text-body',
        },
        {
          key: 'i2Sales',
          label: '2. El Satış',
          sortable: true,
          thClass: 'font-small-2 text-nowrap text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
      ],
    }
  },
}
</script>
